module.exports = __webpack_public_path__ + "img/successright.ed026896.png";